import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconThreeDots = ({ className, height, width, fill }: IconInterface) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill={fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z'
      fill='white'
    />
  </svg>
)

export default Icon(IconThreeDots)
